import { getCountries, getEnvKeys, getMetadata } from "./metadataService";

let countryByName = {};
let countryById   = {};

async function ensureMapsBuilt() {
  // if (countryByName && countryById) return; // already built

  const plist = await getCountries();
  const list = JSON.parse(plist?.countries) || [];
  //console.log("Building country maps from", list, "countries");
  countryByName = {};
  countryById   = {};

  list.forEach(c => {
    if (!c?.Name || !c?.dia_countryid) return;
    countryByName[c.Name.trim().toLowerCase()] = c;
    if (c?.Statecode === 0) {
      countryById[c.dia_countryid] = c;
    }
   
  });
}

export async function getCountryByLabel(label = "") {
  await ensureMapsBuilt();
  const c = countryByName[label.trim().toLowerCase()];
  return c
    ? { dia_countryid: c.dia_countryid, ISO_code: c["ISO code"], Name: c.Name }
    : { dia_countryid: "12ecb77f-2341-e911-a85e-000d3ae0eb6e", ISO_code: "UNKNWN", Name: "Unknown Country" };
}

export async function getCountryNameById(id = "") {
  await ensureMapsBuilt();
  const c = countryById[id];
  // console.log("getCountryNameById", id, c);
  return c ? c.Name : null;
}

export const removeAuthToken = () => {
  localStorage.removeItem("relayState");
}

/**
 * Look up a value inside the metadata cache.
 * 
 * @param section e.g. `"GenderReference"` or `"ApplicationTypeReference"`.
 * @param label   e.g. `"Male"` or `"IVS Adult"`.
 * @returns       The corresponding ID (string) or `null` if not found.
 *
 * Usage:
 *   const id = await getValueFromLabel("GenderReference", "Male");
 *   // id === "dcd24bf2-7a1f-e911-a849-000d3ae0b82e"
 */
export const getValueFromLabel = async (
  section: string,
  label: string
): Promise<string | null> => {
  try {
    const metaRaw = await getMetadata();           // 1️⃣ fetch or localStorage
    if (!metaRaw) return null;

    // 2️⃣  The API returns { metadata: '{ ... }' } so parse twice if necessary.
    const metaObject =
      typeof metaRaw.metadata === "string"
        ? JSON.parse(metaRaw.metadata)
        : metaRaw.metadata;

    const sectionMap = metaObject?.[section];
    if (!sectionMap) return null;

    // 3️⃣  Direct match on the label
    return sectionMap[label] ?? null;
  } catch (err) {
    console.error("Failed to resolve metadata:", err);
    return null;
  }
};


/**
 * Look up a human-readable label (e.g. "Female") from an ID
 * (e.g. "c77f9cf8-7a1f-e911-a849-000d3ae0b82e") inside a metadata section.
 *
 * @param section   e.g. "GenderReference"
 * @param id        e.g. "c77f9cf8-7a1f-e911-a849-000d3ae0b82e"
 * @returns         the matching label or undefined
 */
export async function getLabelFromId(
  section: string,
  id: string
): Promise<string | undefined> {
  const wrapper = await getMetadata();              // { metadata: "{ ... }" }

  // the API wraps the real object in a JSON string, so parse twice:
  const meta =
    typeof wrapper?.metadata === "string"
      ? JSON.parse(wrapper.metadata)
      : wrapper?.metadata;

  const map = meta?.[section];                      // e.g. GenderReference dict
  if (!map) return;

  // reverse-lookup: label is the key whose value === id
  return Object.keys(map).find((label) => map[label] === id);
}

export async function getEnvKeyValue(key) {
  const envKeys = await getEnvKeys();
  if (!envKeys) return null;

  const envMap = JSON.parse(envKeys || "{}");
  return envMap[key] || null;
}

export const calculateAge = (dob) => {
    const birth = new Date(dob);
    const now = new Date();
    let age = now.getFullYear() - birth.getFullYear();
    const m = now.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
    return age;
  };